import { useState } from 'react'
import BillSchedule from './BillSchedule'

import {
  Container,
  Title,
  SubTitle,
  LabelRow
} from './styles'

export default function BillScheduleList ({
  schedules = [],
  professionals = [],
  freeItems = [],
  showFreeItemsValue = false,
  enableEditting = true,
  hasEditPermission = true,
  hasDeletePermission = true,
  services = [],
  onEdit,
  onDelete: handleDelete,
  onToggleFree: handleToggleFree = () => null,
  onRemoveFromBill: handleRemoveFromBill
}) {
  const [editting, setEditting] = useState (false)

  const handleEdit = schedule => {
    setEditting (false)
    onEdit (schedule)
  }

  return schedules.length > 0 && (
    <Container>
      <Title>Agendamentos</Title>
      <LabelRow editting={editting} enableEditting={enableEditting}>
        <SubTitle>Serviço</SubTitle>
        <SubTitle>Profissional</SubTitle>
        <SubTitle>Data</SubTitle>
        <SubTitle>Horário</SubTitle>
        <SubTitle>Comissão</SubTitle>
        <SubTitle>Preço</SubTitle>
        {enableEditting && <SubTitle>Ações</SubTitle>}
      </LabelRow>
      {schedules.map (schedule => (
        <BillSchedule
          key={schedule.id}
          data={schedule}
          professionals={professionals}
          services={services}
          freeItems={freeItems}
          showFreeItemsValue={showFreeItemsValue}
          enableEditting={enableEditting}
          hasEditPermission={hasEditPermission}
          hasDeletePermission={hasDeletePermission}
          onToggleFree={handleToggleFree}
          onToggleEdit={setEditting}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onRemoveFromBill={handleRemoveFromBill}
        />
      ))}
    </Container>
  )
}
